module.exports = __webpack_public_path__ + "media/unipod/mechanical_services_4-2a5bbdb0.jpg";